export default "__VITE_ASSET__Dmgav4Ac__"